// BookSessionModal.jsx
import React, { useEffect, useState } from "react";
import { useAuth } from "../lib/AuthContext";

const BookSessionModal = ({ date, onClose, onSubmit, token }) => {
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const { user } = useAuth();

  useEffect(() => {
    if (!token || !user) return;

    const url = user.role === "client"
      ? "https://quirkleai.com/api/therapists/"
      : "https://quirkleai.com/api/myclients/";

    fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => setUsers(Array.isArray(data) ? data : []))
      .catch(err => {
        console.error("Error fetching list:", err);
        setUsers([]);
      });
  }, [token, user]);

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission
    if (!startTime || !endTime || !selectedUser) {
      alert("Please fill all fields");
      return;
    }

    const payload = {
      start: new Date(`${date}T${startTime}`).toISOString(),
      end: new Date(`${date}T${endTime}`).toISOString(),
      ...(user.role === 'therapist' ? { client_id: selectedUser } : {}),
      ...(user.role === 'client' ? { therapist_id: selectedUser } : {}),
    };

    onSubmit(payload);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow-lg w-96 space-y-4">
        <h2 className="text-xl font-bold">Book Session on {date}</h2>
        <label className="block text-sm text-gray-600 mb-1">
          {user?.role === 'client' ? 'Select Therapist' : 'Select Client'}
        </label>
        <select
          className="w-full border rounded p-2"
          value={selectedUser}
          onChange={(e) => setSelectedUser(e.target.value)}
          required
        >
          <option value="">
            {user?.role === 'client' ? 'Choose Therapist' : 'Choose Client'}
          </option>
          {users.map(u => (
            <option key={u.id} value={u.id}>{u.username}</option>
          ))}
        </select>
        <input
          type="time"
          className="w-full border p-2"
          value={startTime}
          onChange={(e) => setStartTime(e.target.value)}
          required
        />
        <input
          type="time"
          className="w-full border p-2"
          value={endTime}
          onChange={(e) => setEndTime(e.target.value)}
          required
        />
        <div className="flex justify-between">
          <button type="button" onClick={onClose} className="text-gray-600">Cancel</button>
          <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
            Book
          </button>
        </div>
      </form>
    </div>
  );
};

export default BookSessionModal;
